export default __webpack_public_path__ + "static/media/brands-socialbu.8815f848.png";